// Mock data for James Green — Global Real Estate Advisor (frontend-only clone)
// Images referenced from original source for pixel-perfect fidelity.

const IMG = "/images";

export const nav = {
  brand: "eXp",
  brandSub: "LUXURY",
  links: [
    { label: "HOME", target: "hero" },
    { label: "ABOUT", target: "about" },
    { label: "BUY", target: "buy" },
    { label: "SELL", target: "sell" },
    { label: "CONTACT", target: "contact" },
  ],
};

export const hero = {
  kicker: "Global Real Estate Advisor",
  title: "James Green",
  cta: "Explore",
  bg: `${IMG}/hero-bg.png`,
};

export const philosophy = {
  kicker: "My Philosophy",
  title: "More Than a Move",
  body:
    "A move is rarely just about a property. It’s about where you’re going, what matters to you, and making informed decisions along the way. James Green brings clarity, perspective, and a personal approach to every move—helping buyers, sellers, and those relocating throughout Dallas–Fort Worth understand their options and move forward with confidence.",
};

export const panels = [
  {
    id: "meet",
    label: "Meet",
    copy:
      "Two decades of client-first experience across financial services, lending, relocation, and advocacy.",
    cta: "Explore",
    img: `${IMG}/james-meet-seated.png`,
    pos: "center 22%",
    target: "about",
  },
  {
    id: "buy",
    label: "Buy",
    copy: "From first home to forever home — clear guidance through every step of the purchase.",
    cta: "Explore",
    img: `${IMG}/panel-buy.png`,
    target: "buy",
  },
  {
    id: "sell",
    label: "Sell",
    copy: "Strategy, preparation, and market clarity to position your home at its best.",
    cta: "Explore",
    img: `${IMG}/panel-sell.png`,
    target: "sell",
  },
  {
    id: "connect",
    label: "Connect",
    copy: "Tell James about your goals — he will personally follow up.",
    cta: "Explore",
    img: `${IMG}/panel-connect.png`,
    target: "contact",
  },
];

export const about = {
  kicker: "About",
  title: "Meet James Green",
  paragraphs: [
    "For more than two decades, James Green has built his career around people, decisions, and the moments when trusted guidance matters most. His professional background spans financial services, lending, relocation, and client advocacy—experiences that now shape the way he represents his real estate clients across Dallas–Fort Worth.",
    "James brings a calm presence to a process that can often feel anything but. He listens closely, communicates clearly, and has a natural ability to make complex decisions feel more manageable. His approach is measured and solutions-oriented, grounded in understanding not only the property or transaction at hand, but the priorities and circumstances of the person behind it.",
    "That perspective allows James to meet clients wherever they are in their journey. From a first-time buyer working toward homeownership to a family relocating to North Texas or an experienced homeowner preparing for what comes next, he believes exceptional representation should feel personal, informed, and genuinely invested.",
  ],
  primaryCta: "Start a Conversation",
  youtube: "https://www.youtube.com/@JamesAGreenRealEstate",
  img: `${IMG}/james-about-standing-2.png`,
};

export const listing = {
  kicker: "Currently Representing",
  address: "4351 Berylline Lane, Prosper, TX",
  zip: "75078",
  price: "$879,000",
  specs: "6 Beds | 4.5 Baths | 3,764 Sq.Ft.",
  images: [`${IMG}/berylline-1.jpg`, `${IMG}/berylline-6.jpg`],
};

export const testimonials = {
  kicker: "Client Experience",
  title: "In Their Words",
  items: [
    {
      quote:
        "James made my home search in Dallas so much easier, especially navigating it from out of state. He really listened to what I needed, was patient through the whole process, and helped me find a place in Knox-Henderson that I’m genuinely excited about.",
      author: "Hayley Mason",
    },
    {
      quote:
        "From our first conversation, James made selling our home feel effortless. His preparation and market insight positioned us perfectly, and we couldn’t be happier with the outcome.",
      author: "Daniel & Priya R.",
    },
    {
      quote:
        "Relocating to North Texas felt overwhelming until we met James. He oriented us to the right neighborhoods and never made us feel rushed. A true professional.",
      author: "Marcus Bell",
    },
  ],
};

export const buySection = {
  kicker: "Buy",
  title: "Find Your Place",
  body:
    "From established neighborhoods to new communities taking shape across Dallas–Fort Worth, buying here comes with plenty of options. James helps clients explore the areas, homes, and opportunities that align with how they want to live—from location and commute to lifestyle and long-term plans. For those considering new construction, he can help compare communities and builders, understand available incentives and financing offerings, and navigate the choices that come with purchasing a newly built home. For clients relocating to North Texas, having a local resource can make it easier to get oriented, narrow the possibilities, and find the right place to call home.",
  cta: "Get Started",
  img: `${IMG}/buy.png`,
};

export const sellSection = {
  kicker: "Sell",
  title: "Ready for Market",
  body:
    "Every home has something worth highlighting, and thoughtful preparation can shape the way it is experienced from the moment it enters the market. James works with sellers to consider pricing, presentation, and positioning as part of one cohesive strategy, tailored to the property and the goals behind the move. Clients also have access to a preferred network of vendors and trusted professionals who can help prepare and present the home at its best—creating a polished, considered experience from beginning to end.",
  cta: "Let's Talk",
  img: `${IMG}/sell.png`,
};

export const footer = {
  brand: "James Green",
  tagline: "Global Real Estate Advisor",
  email: "James.A.Green@eXpRealty.com",
  phone: "972.876.8030",
  office: {
    lines: ["15950 Dallas Pkwy", "Suite 400", "Dallas, TX 75248"],
    note: "eXp Realty, LLC · Office: (888) 519-7431",
  },
  socials: [
    { name: "instagram", url: "https://www.instagram.com/jamesagreenrealestate" },
    { name: "facebook", url: "https://www.facebook.com/share/1DtRHJMvWu/?mibextid=wwXIfr" },
    { name: "youtube", url: "https://www.youtube.com/@JamesAGreenRealEstate" },
    { name: "tiktok", url: "https://www.tiktok.com/@jamesagreenrealestate" },
    { name: "threads", url: "https://www.threads.com/@jamesagreenrealestate?igshid=NTc4MTIwNjQ2YQ==" },
  ],
  compliance: [
    "Texas Real Estate Commission Consumer Protection Notice",
    "Texas Real Estate Commission Information About Brokerage Services",
    "TREC",
  ],
  disclaimer:
    "All information is deemed reliable but not guaranteed and should be independently reviewed and verified.",
};

export const inquiry = {
  kicker: "Private Inquiry",
  title: "Your Next Move",
  subtitle: "Buying, selling, building, or relocating?\nLet's start the conversation.",
  consent:
    'I agree to be contacted by James Green via call, email and text for real estate services. To opt out, reply "stop" at any time. Message and data rates may apply.',
  cta: "Connect with James",
};


export const contact = {
  kicker: "Private Inquiry",
  title: "Let's Plan Your Move.",
  subtitle:
    "For those considering a purchase, a sale, or a private real estate opportunity — connect with James for thoughtful guidance and discerning representation across Dallas–Fort Worth.",
  interests: ["Buying", "Selling", "Relocating", "New Construction", "Just Exploring"],
  consent:
    'I agree to be contacted by James Green via call, email and text for real estate services. To opt out, reply "stop" at any time. Message and data rates may apply.',
  cta: "Begin the Conversation",
};
